import { render } from "./start.vue?vue&type=template&id=06b78ee8&ts=true"
import script from "./start.ts?vue&type=script&lang=ts&external"
export * from "./start.ts?vue&type=script&lang=ts&external"

import "./start.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__